import { getType } from 'typesafe-actions';
import { RootAction } from '../actions';
import { AccountStatementsActions } from '../actions/AccountStatementsActions';
import { InitialState } from '../initialState';

export const accountStatements = (state = InitialState.accountStatements, action: RootAction) => {
  switch (action.type) {
    case getType(AccountStatementsActions.requestDailyAccountStatements): {
      return {
        ...state,
        dailyStatements: {
          ...state.dailyStatements,
          isLoading: true,
          error: null,
        },
      };
    }
    case getType(AccountStatementsActions.receiveDailyAccountStatements): {
      return {
        ...state,
        dailyStatements: {
          ...state.dailyStatements,
          data: action.payload.data,
          isLoading: false,
          error: null,
        },
      };
    }
    case getType(AccountStatementsActions.errorDailyAccountStatements): {
      return {
        ...state,
        dailyStatements: {
          ...state.dailyStatements,
          isLoading: false,
          error: action.payload.error,
        },
      };
    }
    case getType(AccountStatementsActions.requestMonthlyAccountStatements): {
      return {
        ...state,
        monthlyStatements: {
          ...state.monthlyStatements,
          isLoading: true,
          error: null,
        },
      };
    }
    case getType(AccountStatementsActions.receiveMonthlyAccountStatements): {
      return {
        ...state,
        monthlyStatements: {
          ...state.monthlyStatements,
          data: action.payload.data,
          isLoading: false,
          error: null,
        },
      };
    }
    case getType(AccountStatementsActions.errorMonthlyAccountStatements): {
      return {
        ...state,
        monthlyStatements: {
          ...state.monthlyStatements,
          isLoading: false,
          error: action.payload.error,
        },
      };
    }
    case getType(AccountStatementsActions.requestTaxAccountStatements): {
      return {
        ...state,
        taxStatements: {
          ...state.taxStatements,
          isLoading: true,
          error: null,
        },
      };
    }
    case getType(AccountStatementsActions.receiveTaxAccountStatements): {
      return {
        ...state,
        taxStatements: {
          ...state.taxStatements,
          data: action.payload.data,
          isLoading: false,
          error: null,
        },
      };
    }
    case getType(AccountStatementsActions.errorTaxAccountStatements): {
      return {
        ...state,
        taxStatements: {
          ...state.taxStatements,
          isLoading: false,
          error: action.payload.error,
        },
      };
    }
    default:
      return state;
  }
};
